import React from 'react';
import { Box, IconButton } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';

function ShareButtons({ item }) {
    // --- FIX: Use the unique item URL for sharing ---
    const itemUrl = `https://find.skyrool.com/item/${item._id}`; 
    
    const shareText = `Lost & Found Alert!\nType: ${item.type}\nItem: ${item.itemName}\nLocation: ${item.district}, ${item.state}\n\nFind more details here: ${itemUrl}`;
    
    const encodedText = encodeURIComponent(shareText);
    const encodedUrl = encodeURIComponent(itemUrl);

    const shareLinks = {
        whatsapp: `https://api.whatsapp.com/send?text=${encodedText}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodeURIComponent(`Lost & Found Alert: ${item.itemName}`)}`
    };

    return (
        <Box>
            <IconButton 
                size="small" 
                title="Share on WhatsApp" 
                onClick={() => window.open(shareLinks.whatsapp, '_blank')}
                sx={{ color: '#25D366' }}
            >
                <WhatsAppIcon />
            </IconButton>
            <IconButton 
                size="small" 
                title="Share on Facebook"
                onClick={() => window.open(shareLinks.facebook, '_blank')}
                sx={{ color: '#1877F2' }}
            >
                <FacebookIcon />
            </IconButton>
            <IconButton 
                size="small" 
                title="Share on Twitter"
                onClick={() => window.open(shareLinks.twitter, '_blank')}
                sx={{ color: '#1DA1F2' }}
            >
                <TwitterIcon />
            </IconButton>
        </Box>
    );
}

export default ShareButtons;
